import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GeneralService } from './general.service';
import { environment } from 'src/environments/environment';
import { MsgService } from '../local/msg.service';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';
import { ResponseModel } from '../../models/entity/response.model';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends GeneralService {

  constructor(
    protected messageService: MsgService,
    protected httpClient: HttpClient
  ) {
    super(messageService, httpClient, environment.apiUrl, 'Partner');
  }

  async getListPartner(viewModel: any): Promise<ResponseModel> {
    const res = await this.postCustomApi('GetPartner', viewModel);
    return res;
  }
}
